import { Injectable } from '@angular/core';
import { IPortfolioCompany } from '@common/models/IPortfolioCompany';

@Injectable({
  providedIn: 'root'
})
export class CheckTeamMembersService {

  constructor() { }

  isMemberAdded(company: IPortfolioCompany): boolean {
    const { executionTeam, boardMembers, oversightPartners, investmentCommitteeApprovers } = company?.team || {};
    return !!(executionTeam?.length && boardMembers?.length && oversightPartners?.length && investmentCommitteeApprovers?.length);
  }

  checkTeamMembersOrShowDialog(company: IPortfolioCompany): boolean {
    return this.isMemberAdded(company);
  }
  getMissingTeamRolesString(company: IPortfolioCompany): string {
    const { executionTeam, boardMembers, oversightPartners, investmentCommitteeApprovers } = company?.team || {};
    const missingRoles: string[] = [];
  
    if (!executionTeam || executionTeam.length === 0) {
      missingRoles.push('Execution Team');
    }
    if (!boardMembers || boardMembers.length === 0) {
      missingRoles.push('Board Members');
    }
    if (!investmentCommitteeApprovers || investmentCommitteeApprovers.length === 0) {
      missingRoles.push('Investment Committee Approvers');
    }
    if (!oversightPartners || oversightPartners.length === 0) {
      missingRoles.push('Oversight Partners');
    }
    return missingRoles.join(', ');
  }
  
}
